import { Provider } from '@angular/core';
import {
  CreateSubTaskUseCase,
  GetDetailSubTaskUseCase,
  UpdateSubTaskUseCase,
} from '@app/application/use-cases';
import { SubTaskRepository } from '@domain/repositories';
import { SubTaskRepositoryImpl } from '../repositories/sub-task.repository.impl';

export const SUB_TASK_PROVIDERS: Provider[] = [
  //Repositories
  {
    provide: SubTaskRepository,
    useClass: SubTaskRepositoryImpl,
  },
  {
    provide: CreateSubTaskUseCase,
    useFactory: (subTaskRepo: SubTaskRepository) =>
      new CreateSubTaskUseCase(subTaskRepo),
    deps: [SubTaskRepository],
  },
  {
    provide: UpdateSubTaskUseCase,
    useFactory: (subTaskRepo: SubTaskRepository) =>
      new UpdateSubTaskUseCase(subTaskRepo),
    deps: [SubTaskRepository],
  },
  {
    provide: GetDetailSubTaskUseCase,
    useFactory: (subTaskRepo: SubTaskRepository) =>
      new GetDetailSubTaskUseCase(subTaskRepo),
    deps: [SubTaskRepository],
  },
];
